import { Module } from "vuex";
import { State } from "../store";
import { PLAY_STYLE, PlayStyle } from "@/common/types/PlayStyle";
import { DEFAULT_PREF, Pref } from "@/common/types/Pref";
import merge from "lodash/merge";

export type PrefState = {
  playStyle: PlayStyle;
  pref: Pref;
  prefs: Record<string, Pref>;
};

const prefModule: Module<PrefState, State> = {
  namespaced: true,
  state: {
    playStyle: PLAY_STYLE.SP,
    pref: DEFAULT_PREF,
    prefs: {},
  },
  mutations: {
    setPlayStyle(state, playStyle) {
      state.playStyle = playStyle;
    },
    setPref(state, { uid, pref }) {
      state.pref = pref;
      state.prefs[uid] = pref;
    },
  },
  actions: {
    async setPref({ commit, dispatch }, pref) {
      const uid = (await dispatch("auth/fetchUser", null, { root: true }))?.uid;
      if (!uid || uid === "") {
        throw new Error("unauthorized");
      }
      commit("setPref", { uid, pref });
    },
  },
  getters: {
    getPlayStyle(state) {
      return state.playStyle;
    },
    getPref(state, getter, rootState) {
      const uid = rootState.auth.user?.uid ?? "";
      const pref = state.prefs[uid] ?? state.pref ?? DEFAULT_PREF;
      return merge(DEFAULT_PREF, pref);
    },
  },
};

export default prefModule;
